import { useMutation } from '@tanstack/react-query';
import { useBroadcast } from '../../../common/broadcast-channel/use-broadcast';
import { ConversationMessageView } from '@mark43/cad-api';
import { ConversationKey } from '../../models';
import { useMessagingResource } from './use-messaging-resource';
import { toJS } from 'mobx';

export const useUpdateBookmark = (conversationKey?: ConversationKey) => {
    const { putUserMessageBookmarked } = useMessagingResource();

    const { postMessage } = useBroadcast('update-bookmark');

    type MutateParams = {
        message: ConversationMessageView;
        isBookmarked: boolean;
        conversationKey: ConversationKey;
    };

    const mutation = useMutation<true, unknown, MutateParams, unknown>({
        mutationFn: (variables) => {
            const { message, isBookmarked } = variables;
            return putUserMessageBookmarked(message.userMessageId, isBookmarked);
        },
        onSuccess: (data, variables) => {
            const { message, isBookmarked, conversationKey } = variables;
            const conversationKeyObject = conversationKey.toObject();

            postMessage({
                type: 'UPDATE_BOOKMARK',
                payload: { message: { ...toJS(message), isBookmarked }, conversationKeyObject },
            });
        },
    });

    const updateBookmark = (message: ConversationMessageView, isBookmarked: boolean) => {
        if (conversationKey === undefined) {
            throw new Error('conversationKey is undefined');
        }
        mutation.mutate({
            message,
            isBookmarked,
            conversationKey,
        });
    };

    return { updateBookmark };
};
